import _ from "lodash";
import { useMemo } from "react";
import { useSaleCompStore } from "..";
import useSaleCompsWithFocusArea from "./useSaleCompsWithFocusArea";
import useSaleCompsWithGlobalFilters from "./useSaleCompsWithGlobalFilters";

export default function () {
    const saleCompStore = useSaleCompStore();
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(saleCompStore.saleComps));

    return useMemo(() => {
        const availableOwners = _.sortBy(_.uniq(saleComps.filter(sc => sc.modifiedByUser).map(sc => sc.modifiedByUser!)));

        return ["All Owners", "None"].concat(availableOwners);
    }, [saleComps]);
}